import * as createRouteConfig from 'path-match';
import { RegExpOptions } from 'path-to-regexp';
import { TeamRoutes } from 'typings/enums';

// tslint:disable-next-line:no-any we need to do this to get around the lack of typings for path-match
const castedCreateRoute = createRouteConfig as any as (options?: RegExpOptions) =>
    createRouteConfig.routeFn;

const route = castedCreateRoute({});

export const decisionUrl: createRouteConfig.matchFn = route(
    `${TeamRoutes.Decision}/:view?/:tab?`);

export const cycleIdParameterName = 'cycleId';
export const managerIdParameterName = 'mid';
export const workflowStatusParameterName = 'list';
export const budgetCycleIdParameterName = 'budgetCycleId';
export const reportsParameterName = 'reports';
export const employeeSourceIdParameterName = 'empId';
export const employeeSortParamaterName = 'sortBy';
export const jobFilterParamaterName = 'jobTitle';
export const departmentFilterParamaterName = 'department';
export const promotionFilterParamaterName = 'promotionFilter';
export const employeeFilterParamaterName = 'employee';

export const employeeDecisionUrl: createRouteConfig.matchFn = route(TeamRoutes.EmployeeDecision);
export const payRangeIdParameterName = 'payrangeid';
export const sidePanelParamaterName = 'sidePanel';
export const viewParameterName = 'view';
export const currentBudgetParameter = 'budgetType';
export const workflowViewParamater = 'workflowType';
export const rulesPanelParamater = 'rulesPanel';
export const rulesTabParamater = 'rulesTab';
export const defaultCurrentBudgetView = '';
export const defaultWorkflowView = '';

export const compMemoEmployeeIdParameterName = 'empId';